module.exports = __webpack_public_path__ + "img/6.475fc0c0.png";